

export const ATLAS_VIGENCIA_TARJETA_TEMPORAL=[
 
    {
        Id:1,
        Codigo: 1,
        Descripcion:"1 MES",
        Activo:true,
        Administrador:1, 
    },
    {
        Id:2,
        Codigo:2,
        Descripcion:"2 MES",
        Activo:true,
        Administrador:1, 
    },
    {
        Id:3,
        Codigo:3,
        Descripcion:"3 MES",
        Activo:true,
        Administrador:1, 
    },
    

]




